import { getMunData } from "utils";
const data = getMunData();

const aboutEnglish = {
  title: "About",
  text1: `Infrastructure Management System is a platform specially developed for ${
    data.municipality_title_en
  }  with the objective to facilitate locally elected representatives track progresses of infrastructure projects within the constituency.`,
  text2:
    "Every year, the local government invests a large amount of resources (internal as well as national budget) in infrastructure development. Also, it is one of the key responsibilities of local leaders to adequately monitor in terms of their physical and financial progress.",
  text3:
    "Hence, the Platform is equipped with features and functionalities specifically designed to allow local leader to monitor following:",
  text4:
    "Likewise, the application is also enabled to receive feedback on the projects from citizens as well as other stakeholders on a real-time. Such inputs from citizens work as constructive suggestion in order to ensure effectiveness of infrastructure projects.",
  text5: `${data.municipality_title_en}`,
  text6: "Government of Nepal",
  list1:
    "See the list of projects planned for a specific fiscal year distributed across wards.",
  list2:
    "Easily see the statuses of projects as their nature, planned, started/not started,tendered, contracted and completed.",
  list3:
    "Get details of individual projects tender amount, tenderers, contract start date, works completion date etc.",
  list4: "See physical progress as well as financial progress of each projects."
};

const aboutNepali = {
  title: "पूर्वाधार व्यवस्थापन प्रणालीका बारेमा",
  text1: `पूर्वाधार व्यवस्थापन प्रणालीलाई ${data.municipality_title}का जननिर्वाचित प्रतिनिधि एवं पदाधिकारीहरुलाई अाफ्नाे क्षेत्रमा भइरहेका पूर्वाधार विकास परियाेजनाकाे प्रगतिकाे अनुगमनमा सहायक हुने गरी विकास गरिएकाे प्रणाली हाे । `,
  text2:
    "प्रत्येक वर्ष स्थानिय सरकारले ठूलाे स्राेत (आन्तरिक एवं संघीय) पूर्वाधार विकासका लागि खर्च गर्ने गर्दछ । त्यसैकारण, त्यस्ता परियाेजनाहरुकाे भाैतिक प्रगति एवं वित्तिय प्रगती के कसरी भईरहेकाे छ भनी अनुगमन गर्नु पनि जननिर्वाचित प्रतिनिधि एवं पदाधिकारीहरुकाे प्रमुख कार्य हाे ।",
  text3:
    "तसर्थ, पूर्वाधार व्यवस्थापन प्रणालीलाई त्यस्ता परियाेजनाहरुका विभिन्न पक्षका तथ्यांक हेर्न र विश्लेषण गर्न सकिने गरी विकास गरिएकाे छ ।जस्तैः",
  text4:
    "त्यसैगरी, यस प्रणालीअन्तर्गतकाे माेबाईल एपकाे माध्यमद्धारा नागरिक एवं अन्य सराेकारवालाहरुले परियाेजनाबारे आफ्ना प्रतिकृयाहरु समेत तत्काल पठाउन सक्दछन् । नागरिकका तर्फबाट आउने त्यस्ता सुझावहरुले परियाेजनाकाे प्रभावकारीता अभिवृद्दी गर्नमा सहयाेग पुर्याउँदछ ।",
  text5: `${data.municipality_title}`,
  text6: "नेपाल सरकार ",
  list1:
    "विभिन्न आर्थिक वर्षहरुमा विभिन्न वडामा सञ्चालन गर्ने गरी याेजना गरिएका परियाेजनाकाे सूची",
  list2:
    "परियाेजनाहरुकाे प्रकृतिका आधारमा साेकाे हालकाे अवस्थाका बारेमा सहज रुपमा जानकारी ",
  list3:
    "कुनै एक परियाेजनाकाे विस्तृत विवरण । जस्तै, टेण्डर मूल्य, बाेलपत्रदाताहरु, सम्झौता सुरु हुने मिति, कार्य सम्पन्न हुने मिति, आदी ।",
  list4: "प्रत्येक परियाेजनाकाे भाैतिक एवं वित्तीय प्रगति"
};

export { aboutEnglish, aboutNepali };



// WEBPACK FOOTER //
// ./src/localization/about.js